class ConfirmTippy {
    constructor(selector = '[data-tippy="confirm"]', tippy, options = {}) {
        this.selector = selector;
        this.options = Object.assign({
            approveText: 'Approva',
            cancelText: 'Annulla',
            fetchOptions: {},
            urlAttribute: 'data-url',
            popoverMessage: 'Sei sicuro di voler procedere?',
            resultHtmlContainer: '#confirm-action-result-html'
        }, options);

        this.tippy = tippy;
        this._ensureToastContainer();
        this._ensureResultHtmlContainer();
    }

    init() {
        document.querySelectorAll(this.selector).forEach(button => {
            if (!button._tippyConfirmAttached) {
                // Prevent default on the actual button click
                button.addEventListener('click', function(e) {
                    e.preventDefault();
                });

                this.tippy(button, {
                    content: this._getPopoverContent(button),
                    allowHTML: true,
                    trigger: 'click',
                    interactive: true,
                    placement: 'top',
                    theme: 'light-border',
                    onShow: (instance) => {
                        setTimeout(() => this._attachPopoverEvents(instance, button), 0);
                    },
                });
                button._tippyConfirmAttached = true;
            }
        });        
    }

    _getPopoverContent(button) {
        // Per-button overrides or fallback to defaults
        const message = button.getAttribute('data-confirm-message') || this.options.popoverMessage;
        const approveText = button.getAttribute('data-approve-text') || this.options.approveText;
        const cancelText = button.getAttribute('data-cancel-text') || this.options.cancelText;
        return `
            <div class="text-center" style="min-width:260px;">
                <div style="margin-bottom:.75em">${message}</div>
                <button type="button" class="btn btn-sm btn-primary tippy-approve me-2" style="min-width:100px;">${approveText}</button>
                <button type="button" class="btn btn-sm btn-secondary tippy-cancel" style="min-width:100px;">${cancelText}</button>
            </div>
        `;        
    }

    _attachPopoverEvents(instance, button) {
        const popper = instance.popper;
        const approveBtn = popper.querySelector('.tippy-approve');
        const cancelBtn = popper.querySelector('.tippy-cancel');
        if (!approveBtn || !cancelBtn) return;

        approveBtn.onclick = (e) => {
            e.preventDefault();
            instance.hide();
            const url = button.getAttribute(this.options.urlAttribute);
            if (!url) {
                this._showToast('Errore', 'URL non specificato!', 'danger');
                return;
            }
            this._approve(url, button);
        };
        cancelBtn.onclick = (e) => {
            e.preventDefault();
            instance.hide();
        };
    }

    // _approve(url, button) {
    //     fetch(url, Object.assign({ method: 'POST' }, this.options.fetchOptions))
    //         .then(r => r.json())
    //         .then(data => {
    //             if (data.js) this._injectHtmlAndRunJs(data.js);
    //             if (data.success) {
    //                 this._showToast('Successo', 'Operazione completata con successo!', 'success');
    //             } else {
    //                 this._showToast('Errore', 'Errore durante l\'operazione.', 'danger');
    //             }
    //         })
    //         .catch(() => this._showToast('Errore', 'Errore di rete!', 'danger'));
    // }

    _approve(url, button) {
        fetch(url, Object.assign({ method: 'POST' }, this.options.fetchOptions))
            .then(r => r.json())
            .then(data => {
                if (data.js) this._injectHtmlAndRunJs(data.js);
                if (data.success) {
                    this._showToast('Successo', 'Operazione completata con successo!', 'success');
                    this._removeTargetElement(button);
                } else {
                    this._showToast('Errore', 'Errore durante l\'operazione.', 'danger');
                }
            })
            .catch(() => this._showToast('Errore', 'Errore di rete!', 'danger'));
    }

    _removeTargetElement(button) {
        if (!button) return;
        const selector = button.getAttribute('data-remove-target');
        if (!selector) return;
        const el = document.querySelector(selector);
        if (el && el.parentNode) {
            el.parentNode.removeChild(el);
        }
    }

    _injectHtmlAndRunJs(jsAndHtml) {
        // Create a dummy container to parse the string
        const container = document.createElement('div');
        container.innerHTML = jsAndHtml;

        // Extract and run scripts
        const scripts = Array.from(container.querySelectorAll('script'));
        scripts.forEach(script => {
            const newScript = document.createElement('script');
            if (script.src) {
                newScript.src = script.src;
            } else {
                newScript.textContent = script.textContent;
            }
            document.body.appendChild(newScript);
            // Clean up the script tag after execution
            setTimeout(() => newScript.remove(), 100);
            script.remove();
        });

        // The remaining HTML is injected
        const htmlContent = container.innerHTML.trim();
        if (htmlContent) {
            const target = document.querySelector(this.options.resultHtmlContainer);
            if (target) {
                target.innerHTML = htmlContent;
            }
        }
    }

    _ensureToastContainer() {
        if (!document.getElementById('toast-container')) {
            const toastContainer = document.createElement('div');
            toastContainer.id = 'toast-container';
            toastContainer.className = 'toast-container position-fixed bottom-0 end-0 p-3';
            toastContainer.style.zIndex = '1080';
            document.body.appendChild(toastContainer);
        }
    }

    _ensureResultHtmlContainer() {
        if (!document.querySelector(this.options.resultHtmlContainer)) {
            const div = document.createElement('div');
            div.id = this.options.resultHtmlContainer.replace('#', '');
            document.body.appendChild(div);
        }
    }

    _showToast(title, message, type = 'info') {
        const toastId = `toast-${Math.random().toString(36).substr(2,9)}`;
        const bgClass = {
            success: 'bg-success text-white',
            danger: 'bg-danger text-white',
            warning: 'bg-warning text-dark',
            info: 'bg-info text-dark'
        }[type] || 'bg-info text-dark';

        const toastHtml = `
        <div id="${toastId}" class="toast align-items-center ${bgClass}" role="alert" aria-live="assertive" aria-atomic="true" data-bs-delay="4000">
          <div class="d-flex">
            <div class="toast-body">
              <strong>${title}</strong><br>${message}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Chiudi"></button>
          </div>
        </div>`;
        document.getElementById('toast-container').insertAdjacentHTML('beforeend', toastHtml);
        const toastElem = document.getElementById(toastId);
        const toast = new bootstrap.Toast(toastElem);
        toast.show();
        toastElem.addEventListener('hidden.bs.toast', () => toastElem.remove());
    }
}

export default ConfirmTippy;

/*
HTML for injected content:
<div id="confirm-action-result-html"></div>

Example button:
<button
  data-tippy="confirm"
  data-url="/api/delete-item/123"
  data-remove-target="#row-123"
  data-confirm-message="Eliminare la riga?"
  data-approve-text="Conferma"
  data-cancel-text="Annulla operazione"
  class="btn btn-danger"
>
  Elimina
</button>
*/
